import { createSlice } from "@reduxjs/toolkit";

export function initialPreferencesState() {
    return {
        userId: "",
        preferences: {},
        isLoading: true,
    };
}

const preferencesSlice = createSlice({
    name: "preferences",
    initialState: initialPreferencesState(),
    reducers: {
        set_user: (state, action) => {
            return {
                ...state,
                userId: action.payload.userId,
                preferences: {},
                isLoading: true,
            };
        },
        update_preference: (state, action) => {
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    [action.payload.preference]: action.payload.value,
                },
            };
        },
        receive_preferences: (state, action) => {
            return {
                ...state,
                isLoading: false,
                preferences: {
                    ...action.payload.preferences,
                    ...state.preferences,
                },
            };
        },
    },
});

export const { set_user, update_preference, receive_preferences } =
    preferencesSlice.actions;

export default preferencesSlice.reducer;
